@if (appScope.isAuthenticated$ | async) {
  <div appUserInteraction class="body" [ngClass]="currentTheme">
    @if (!headerData.hidePageLoader) {
      <ngx-loading-bar [color]="loadingBarColour"></ngx-loading-bar>
    }
    <main-header></main-header>
    <main-sidenav></main-sidenav>
    @if (appScope.userOnboarded | async) {
      <comment-drawer [ngClass]="{'showing_comments_panel': showing_comments_panel}" class="hideonprint"></comment-drawer>
      <print-content></print-content>
    }
  </div>
}

@if (appScope.authFailed$ | async) {
    <src-no-account [ngClass]="currentTheme"></src-no-account>
}
